import client from '../../services/client';

export const resetPassword = (token, password) => client.post('reset_password', {
  token,
  password,
})
  .then((response) => response.data);
